module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Stills_2_Katfish-25f527e6feb5f1c00a33d8e2ab0c9fd9.jpg";